import ReactGA from 'react-ga4';

// Initialize GA4
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
  
  if (measurementId) {
    ReactGA.initialize(measurementId, {
      gtagOptions: {
        send_page_view: true
      }
    });
    console.log('GA4 initialized with ID:', measurementId);
  } else {
    console.warn('GA4 Measurement ID not found');
  }
};

// Track page views
export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

// Track custom events
export const trackEvent = (category, action, label = '', value = 0) => {
  ReactGA.event({
    category,
    action,
    label,
    value
  });
};

// Track button clicks
export const trackButtonClick = (buttonName, location) => {
  trackEvent('Button Click', buttonName, location);
};

// Track form submissions
export const trackFormSubmission = (formName, success = true) => {
  trackEvent('Form', success ? 'Submit Success' : 'Submit Failed', formName);
  
  // Track as conversion
  if (success) {
    ReactGA.event('generate_lead', {
      form_name: formName,
      value: 1
    });
  }
};

// Track plan selection
export const trackPlanSelection = (planName, planPrice) => {
  trackEvent('Plan Selection', 'Select Plan', planName, planPrice);
  
  // Track as conversion
  ReactGA.event('select_content', {
    content_type: 'plan',
    content_id: planName,
    value: planPrice
  });
};

// Track user engagement
export const trackEngagement = (action, label) => {
  trackEvent('User Engagement', action, label);
};

// Track outbound links
export const trackOutboundLink = (url, linkName) => {
  trackEvent('Outbound Link', 'Click', `${linkName} - ${url}`);
};
